import ApiService from 'common/service/api';
import { PublicError } from 'common/service/error';
import { catchError, map } from 'rxjs/operators';

export default class GroupService extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `/ws`;
  }

  remove(groupName) {
    return this
      .fetchResource(`/meterGroup/${groupName}`, { method: 'DELETE' })
      .pipe(
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.message, err.response.message);
          }

          throw err;
        }),
      );
  }

  create(group) {
    return this
      .post('/meterGroup', group)
      .pipe(
        map(ApiService.resourceJson),
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.name ?
                                  err.response.name :
                                  err.response.meterGroupName ?
                                  err.response.meterGroupName :
                                  err.response.message);
          }

          throw err;
        }),
      );
  }

  addDevices(group) {

    const { deviceNames, groupName } = group;

    return this
      .post(`/modifyMeterGroup/${groupName}/devices`, deviceNames)
      .pipe(
        map(ApiService.resourceJson),
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.message);
          }
          throw err;
        }),
      );
  }

  removeDevices(group){

    const { deviceNames, groupName } = group;

    return this
    .delete(`/modifyMeterGroup/${groupName}/devices`, deviceNames)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      }),
    );
  }

}
